<template>
  <div>
    <div class="detailed-info">
      <div class="detailed-info__block-1">
        <div class="detailed-info-device">
          <v-col cols="12" sm="12" class="pb-0">
            <div class="snapshot-device" v-if="barrier.device && barrier.device.model !== 'RACS-1101'">
              <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
              <v-img
                :src="snapshot"
                max-width="550"
                max-height="400"
                class="image-device mt-2"
                @click.stop="getDialogImage"
                alt="Изображение отсутствует"
              ></v-img>
              <v-dialog
                v-if="disableRoleNameAdmin"
                v-model="dialogImage"
                :max-width="isMobile ? '70%' : '45%'"
                content-class="over-dialog"
                style="height: 528px;"
              >
                <div
                  :style="isMobile ? 'height: 100%;' : 'height: 528px;'"
                  style="position: relative; width: 100%;"
                >
                  <Player
                    v-if="dialogImagePlayer"
                    ref="Player"
                    :key="channel.id"
                    :channel="channel"
                  />
                </div>
              </v-dialog>
              <v-dialog v-else v-model="dialogImage" :max-width="isMobile ? '90%' : '50%'">
                <div class="preloader" v-if="videoLoader">
                  <v-progress-circular
                    :size="75"
                    :width="7"
                    color="primary"
                    :indeterminate="videoLoader"
                    class="preloader-circular"
                  >
                  </v-progress-circular>
                </div>
                <video
                  class="dialog-video"
                  ref="streamEl"
                  alt="Видео отсутствует"
                  autoplay
                ></video>
              </v-dialog>
            </div>
            <div v-if="!barrier.device">
              <v-img
                max-width="500"
                contain
                class="image-barrier border mt-2"
                :src="require('../../../../../public/barrier-old.jpg')"
                @click="zoomPhoto(require('../../../../../public/barrier-old.jpg'))">
              </v-img>
            </div>
            <div v-if="barrier.device && barrier.device.model === 'RACS-1101'">
              <v-img
                height="280"
                contain
                class="image-gate border mt-2"
                :src="require('../../../../../public/controllerRacs.png')"
                @click="zoomPhoto(require('../../../../../public/controllerRacs.png'))">
              </v-img>
            </div>
            <v-dialog v-model="showZoomPhoto" :max-width="isMobile ? '90%' : '50%'" @input="closeZoomPhoto">
              <zoom-photo
                v-model="showZoomPhoto"
                :photo="currentZoomPhoto"
                @closeZoomPhoto="closeZoomPhoto()"
              >
              </zoom-photo>
            </v-dialog>
          </v-col>

          <v-dialog v-model="showDialogTwoButtons" max-width="400" content-class="dialog-border-radius">
            <v-card class="pa-2">
              <v-card-title class="text-h5">Выберите реле для открытия</v-card-title>
              <v-card-text>
                Пожалуйста, выберите реле, которое нужно открыть.
              </v-card-text>
              <v-card-actions style="display: block; text-align: center">
                <v-btn color="primary" @click="handleOpen(1)">Открыть Реле 1</v-btn>
                <v-btn color="primary" @click="handleOpen(2)">Открыть Реле 2</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-col class="detailed-info-device__box-2">
            <detailed-info
              :barrier="barrier"
              :is-check-size-small="isCheckSizeSmall"
            />
          </v-col>
          <v-col cols="12" sm="12" class="detailed-info-device__box-3">
            <v-card class="border card-info-clue">
              <v-carousel
                :cycle="roleName !== 'admin'"
                interval="8000"
                show-arrows-on-hover
                height="400"
                hide-delimiter-background
              >
                <v-carousel-item>
                  <v-sheet color="#4C6C93" height="100%">
                    <div class="pa-6">
                      <h1 class="info-warning">
                        <div>
                          <div v-for="(item, index) in statistics" :key="index">
                            <statistic-label-info
                              :label="item.label"
                              :value="item.value"
                              :check="item.check"
                              :icon="item.icon"
                              :br-check="item.brCheck"
                              :to="item.to"
                              :is-router-link="item.isRouterLink"
                              :is-check-size-small="isCheckSizeSmall"
                            />
                          </div>
                          <div>
                            <template v-if="barrier.physical_status === 5">
                              <h4 class="h4-statistics-device mt-4">
                                Шлагбаум старого образца.
                                {{ oldBarrierAppSummary }}
                              </h4>
                            </template>
                            <h4 v-if="!(barrier.physical_status === 5 && isCheckSizeSmall)" class="h4-statistics-device">
                              Устройство
                            </h4>
                            <p>Модель шлагбаума: {{ displayLabelSettings('model_barrier', barrier.model_barrier) }}</p>
                            <p>Тип модуля GSM: {{ displayLabelSettings('gsm_module_type', barrier.gsm_module_type) }}</p>
                            <p>Пульты: {{ displayLabelSettings('remotes', barrier.remotes) }}</p>
                            <p class="mb-2">Магнитная петля: {{ displayLabelSettings('magnetic_loop', barrier.magnetic_loop) }}</p>
                            <template v-if="barrier.physical_status !== 5">
                              <p>IP-адрес: {{ barrier.device.ip_address }}</p>
                              <p>Производитель: {{ barrier.device.manufacturer }}</p>
                              <p v-if="barrier.device.mac_address && !isCheckSizeSmall">
                                MAC-адрес: {{ barrier.device.mac_address }}
                              </p>
                            </template>
                          </div>
                        </div>
                      </h1>
                    </div>
                    <div style="position: absolute; bottom: 15px; right: 15px;">
                      <v-icon style="font-size: 50px; height: inherit;" color="#87A1B9">mdi-information-outline</v-icon>
                    </div>
                  </v-sheet>
                </v-carousel-item>
                <v-carousel-item v-for="(slide, i) in slides" :key="i">
                  <v-sheet :color="slide.color" height="100%">
                    <div class="pa-6">
                      <h1 class="info-warning">
                        <div v-html="slide.title" />
                      </h1>
                    </div>
                    <div style="position: absolute; bottom: 15px; right: 15px;">
                      <v-icon style="font-size: 50px; height: inherit;" :color="slide.colorIcon">{{ slide.icon }}</v-icon>
                    </div>
                  </v-sheet>
                </v-carousel-item>
              </v-carousel>
            </v-card>
          </v-col>
        </div>
      </div>
      <div class="detailed-info__block-2">
        <v-row no-gutters>
          <v-col cols="12" sm="11" class="mt-4" style="cursor: pointer;">
            <div
              v-for="page in pageStore"
              :key="page.title"
              class="hover-scale-effect"
            >
              <v-card
                class="border card-info-btn"
                :color="page.colorCard"
                :class="{'disabled' : page.isDisabled }"
                v-if="page.show"
                @click="handleClick(page)"
              >
                <div style="display: flex; height: 100%">
                  <v-card style="border-radius: 16px; width: 35%; height: 100%; text-align: center;" :color="page.colorCardIcon">
                    <v-icon style="font-size: 40px; height: inherit;" color="white">{{ getIcon(page) }}</v-icon>
                  </v-card>
                  <div class="btn-page-store" v-html="page.title" />
                </div>
              </v-card>
            </div>
          </v-col>
          <v-dialog v-model="dialogBuyBarrier" max-width="800" content-class="dialog-border-radius">
            <BaseSaleItemDoorphoneModal
              :active.sync="dialogBuyBarrier"
              @close="dialogBuyBarrier = false"
              type-services="buyKeyBarrier"
              price-key="250"
              header=" Продажа брелока от шлагбаума (ворот) "
              icon="mdi-car-connected"
              :is-cellar="true"
              :basic-info-devices="basicInfoDevices"
            />
          </v-dialog>
        </v-row>
      </div>
    </div>
      <v-row no-gutters class="pb-4 mt-2">
      <v-col cols="12" sm="12" md="7" lg="7">
        <v-card v-if="barrier.doorphones[0]" class="border info-additional">
          <div class="pa-4 tied">
            <p v-if="barrier.doorphones[0]">
              Привязанные домофоны:
              <template v-for="(tmp, index) of displayedIntercoms">
                <router-link class="routerLink" v-bind:key="tmp.id" :to="`/doorphones/${tmp.id}`">
                  Домофон №{{ tmp.id }}
                </router-link>
                <template v-if="index !== barrier.doorphones.length - 1">,</template>
              </template>
              .
              <span v-show="barrier.doorphones.length > 4" class="ml-2">
                  <v-btn @click="toggleIntercoms">
                    <v-icon>{{ showAllIntercoms ? 'mdi-chevron-triple-left' : 'mdi-chevron-triple-right' }}</v-icon>
                  </v-btn>
                </span>
            </p>
          </div>
        </v-card>
      </v-col>
      <v-col class="col-btn-additional">
        <div
          v-for="page in additionalButtons"
          :key="page.title"
          style="display: flex"
        >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-if="page.show"
                :color="page.colorCard"
                class="border card-footer-button hover-scale-effect"
                v-bind="attrs"
                v-on="on"
                :disabled="page.isDisabled"
                @click="page.click"
                style=""
              >
                <v-icon style="font-size: 40px; height: inherit;" color="white">{{ getIcon(page) }}</v-icon>
              </v-btn>
            </template>
            <span>{{ page.title }}</span>
          </v-tooltip>
        </div>
      </v-col>
      <v-dialog v-model="detailDialog" max-width="800" content-class="dialog-border-radius">
        <DetailDeviceModal
          :active.sync="detailDialog"
          @close="detailDialog = false"
          :device="barrier.device"
        />
      </v-dialog>
      <AddPhoneModal
        v-if="isModalOpen"
        :isOpen="isModalOpen"
        :phoneData="phoneData"
        @close="closeModal"
        @save="handleSave"
      />
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import DetailDeviceModal from '../../../device/DetailDeviceModal.vue';
import ruDateFormatMixin from '@/mixins/ruDateFormat';
import StatisticLabelInfo from '@/components/StatisticLabelInfo.vue';
import AddPhoneModal from './GeneralInfo/components/AddPhoneModal.vue';
import zoomPhoto from '@/components/client/DetailClient/components/zoomPhoto.vue';
import Hls from 'hls.js';
import DetailedInfo from './GeneralInfo/components/DetailedInfo.vue';
import BaseSaleItemDoorphoneModal from '@/components/baseModal/BaseSaleItemDoorphoneModal.vue';
import { ENUM_LABELS } from '../../consts';

export default {
  components: {
    DetailedInfo,
    zoomPhoto,
    StatisticLabelInfo,
    BaseSaleItemDoorphoneModal,
    DetailDeviceModal,
    AddPhoneModal,
  },
  mixins: [ruDateFormatMixin],
  name: 'GeneralInfo',
  props: {
    resComplexName: Array,
    totalAccounts: Number,
    totalNumberCars: Number,
    totalTemporarySubscribers: Number,
    totalWhitePhoneNumbers: Number,
  },
  data () {
    return {
      streamUrl: '',
      detailDialog: false,
      channel: {
        id: this.$route.params.id,
        address: '',
        streamUrl: '',
        link: '',
      },
      snapshot: null,
      hls: null,
      activeButton: null,
      showZoomPhoto: false,
      currentZoomPhoto: '',
      loading: false,
      isMobile: false,
      dialogImage: false,
      isFirstTimeDialogImageOpened: false,
      disableRoleNameAdmin: false,
      isErrorStreamUrl: false,
      dialogBuyBarrier: false,
      videoLoader: true,
      disableRoleName: false,
      isCheckSizeSmall: false,
      isUpdatedSip: false,
      dialogImagePlayer: false,
      showAllIntercoms: false,
      showDialogTwoButtons: false,
      basicInfoDevices: [],
      allAbonents: '',
      allTemporarySubscribers: '',
      allNumbersCars: '',
      isModalOpen: false,
      phoneData: {
        phone: '',
        name: '',
        action: true,
        code: '',
      },
    };
  },
  created () {
    if (this.barrier.device) {
      this.getCheckCamerasBarrier({
        id: this.$route.params.id,
      })
        .then((data) => {
          const stream = data.data.data.stream_url;
          this.streamUrl = {
            url: stream,
          };
          this.channel.link = `${process.env.VUE_APP_API_URL}/barrier/${this.channel.id}/camera-archive`;
          this.channel.streamUrl = this.streamUrl.url;
        })
        .catch((err) => {
          this.isErrorStreamUrl = true;
          this.streamUrl = {
            error: err.response.data.error,
          };
        });
    }
    switch (this.roleName) {
      case 'admin': case 'admin-engineer' : this.disableRoleName = true;
        break;
    }
    switch (this.roleName) {
      case 'admin' : this.disableRoleNameAdmin = true;
        break;
    }
    window.addEventListener('resize', this.checkSize);
    this.checkSize();
  },

  watch: {
    dialogImage: function (val) {
      if (!val) {
        if (this.disableRoleNameAdmin && this.$refs.Player?.destroy) {
          this.$refs.Player.destroy();
        }
        if (this.hls) {
          this.hls.stopLoad();
          this.hls.detachMedia();
          this.hls.destroy();
          this.hls = null;
        }
        this.dialogImagePlayer = false;

        return;
      }

      setTimeout(() => {
        this.dialogImagePlayer = this.dialogImage;
      }, 200);
      this.$nextTick(() => {
        if (val && Hls.isSupported()) {
          if (this.streamUrl.url) {
            const hls = new Hls();
            hls.loadSource(this.streamUrl.url);
            hls.attachMedia(this.$refs.streamEl);
            hls.once(Hls.Events.BUFFER_APPENDING, () => {
              this.videoLoader = false;
            });
            hls.once(Hls.Events.ERROR, () => {
              this.dialogImage = false;
              this.videoLoader = false;
              this.$flash_warning('Произошла ошибка во время воспроизведения или загрузки видео');
              hls.stopLoad();
              hls.detachMedia();
            });
            this.hls = hls;
          } else {
            this.dialogImage = false;
            this.$flash_warning(this.streamUrl.error);
            if (this.hls) {
              if (this.disableRoleNameAdmin) {
                this.$refs.Player.beforeUnmount();
                this.isFirstTimeDialogImageOpened = true;
              }
              this.hls.stopLoad();
              this.hls.detachMedia();
              this.hls.destroy();
            }
          }
        } else {
          if (this.hls) {
            if (this.disableRoleNameAdmin) {
              this.$refs.Player.beforeUnmount();
              this.isFirstTimeDialogImageOpened = true;
            }
            this.hls.stopLoad();
            this.hls.detachMedia();
            this.hls.destroy();
            this.videoLoader = true;
          }
        }
      });
    },
  },
  computed: {
    ...mapGetters({
      barrier: 'Barriers/barrier',
      roleName: 'roleName',
    }),
    displayedIntercoms () {
      return this.showAllIntercoms ? this.barrier.doorphones : this.barrier.doorphones.slice(0, 4);
    },
    hasGsmModule () {
      if (this.barrier.gsm_module || this.barrier.gsm_module_device_id) {
        return true;
      }
      const gsmType = this.barrier.gsm_module_type;
      return Boolean(gsmType && gsmType !== 'None');
    },
    oldBarrierAppSummary () {
      if (!this.barrier.display_in_app) {
        return 'Шлагбаум не отображается в приложении.';
      }
      if (this.hasGsmModule) {
        return 'Отображается в приложении, открытие через приложение есть, для клиента визуально без отличий.';
      }
      return 'Отображается в приложении, но без GSM открытие из приложения недоступно — только звонок/пульт.';
    },
    slides () {
      if (this.barrier.physical_status === 5) {
        const appHint = !this.barrier.display_in_app
          ? 'Шлагбаум не отображается в приложении.<br><br>' +
            'Доступны только способы из типа открытия: звонок и/или пульт.'
          : this.hasGsmModule
            ? 'Шлагбаум отображается в приложении, открытие через приложение присутствует.<br><br>' +
              'Для клиента визуально нет отличия: в приложении всё выглядит как обычно.<br><br>'
            : 'Шлагбаум отображается в приложении, но GSM-модуль не указан.<br><br>' +
              'Открытие из приложения недоступно. Доступны только способы из типа открытия: звонок и/или пульт.';

        return [
          {
            title: 'Шлагбаум старого образца.<br><br>' + appHint,
            color: '#E0B389',
            colorIcon: '#87A1B9',
            icon: 'mdi-information-outline',
          },
          {
            title: 'Важно обращать внимание на агента.<br><br>Агент - это компания осуществляющая обслуживание ' +
              'оборудования и монтаж устройства <br><br>Заявки на ремонт и установку необходимо передавать им.',
            color: '#1f3965',
            colorIcon: '#87A1B9',
            icon: 'mdi-information-outline',
          },
        ];
      }

      return [
        {

          title: 'Шлагбаумы могут иметь разные варианты дистанционного управления.<br><br>Вы можете выбрать управление ' +
            'шлагбаумом с помощью пульта, телефона, или через приложение. Это позволяет пользователям открывать ' +
              'шлагбаум удаленно, не выходя из машины.',
          color: '#E0B389',
          colorIcon: '#87A1B9',
          icon: 'mdi-information-outline',
        },
        {
          title: 'Важно обращать внимание на агента.<br><br>Агент - это компания осуществляющая обслуживание ' +
            'оборудования и монтаж устройства <br><br>Заявки на ремонт и установку необходимо передавать им.',
          color: '#1f3965',
          colorIcon: '#87A1B9',
          icon: 'mdi-information-outline',
        },
        {
          title: 'Обратите внимание на тип пропуска для шлагбаума.<br><br>Шлагбаум может быть настроен на разные' +
            'типы пропуска: по звонку, по госномеру автомобиля или их комбинации. Настройте тип доступа в зависимости' +
            'от требований вашей территории для удобного управления въездом или выездом.',
          color: '#fd7b7b',
          colorIcon: '#87A1B9',
          icon: 'mdi-information-outline',
        },
      ];
    },
    additionalButtons () {
      return [
        {
          title: 'Редактировать',
          color: '#1E6CEB',
          icon: 'mdi-pencil',
          colorCard: '#1E6CEB',
          show: this.$checkPermission('edit_barrier'),
          click: this.editDoorphone,
        },
        {
          title: 'Открыть шлагбаум',
          color: 'success',
          icon: 'mdi-location-exit',
          colorCard: '#85B285',
          show: this.$checkPermission('open_barrier'),
          click: this.openDeviceClick,
          isDisabled: this.hasOpeningType(this.barrier.opening_type, 'RC') && !this.hasOpeningType(this.barrier.opening_type, 'C'),
        },
        {
          title: 'Обновить изображение',
          color: '#1E6CEB',
          icon: 'mdi-reload',
          colorCard: '#4C6C93',
          click: this.updateSnapshotClick,
          show: this.$checkPermission('update_snapshot_barrier') &&
            this.barrier.device &&
            this.barrier.device.model !== 'RACS-1101',
          isDisabled: this.barrier.physical_status === 5,
        },
        {
          title: 'Включить открытие по грз',
          color: 'success',
          icon: 'mdi-car-cog',
          colorCard: '#39a839',
          show: this.$checkPermission('unlocking_barrier') && this.barrier.status_condition === 'off',
          click: this.unlockingDevice,
          isDisabled: this.barrier.physical_status === 5,
        },
        {
          title: 'Выключить открытие по грз',
          color: 'error',
          icon: 'mdi-car-cog',
          colorCard: '#B81B1B',
          show: this.$checkPermission('blocking_barrier') && this.barrier.status_condition === 'on',
          click: this.blockingDevice,
          isDisabled: this.barrier.physical_status === 5,
        },
        {
          title: 'Информация о устройстве',
          color: '#1E6CEB',
          icon: 'mdi-information-outline',
          colorCard: '#4C6C93',
          click: this.openDetailDialogDevice,
          show: true,
          isDisabled: this.barrier.physical_status === 5,
        },
        {
          title: 'Переход на web морду',
          color: '#1E6CEB',
          icon: 'mdi-monitor-eye',
          colorCard: '#4C6C93',
          click: this.transitionWebDevice,
          show: this.disableRoleName,
          isDisabled: this.barrier.physical_status === 5,
        },
      ];
    },
    pageStore () {
      const remoteLinks = {
        P: 'https://b24-d5ej1n.bitrix24.site/crm_form_q4d7h/',
        D: 'https://b24-d5ej1n.bitrix24.site/crm_form_ppekp/',
        U: 'https://b24-d5ej1n.bitrix24.site/crm_form_ppekp/',
        N: 'https://b24-d5ej1n.bitrix24.site/crm_form_eg38z/',
        A: 'https://b24-d5ej1n.bitrix24.site/crm_form_c0xvx/',
      };

      const remoteKey = this.barrier.remotes?.trim();
      const isRemoteSet = remoteKey && remoteKey in remoteLinks;

      return [
        {
          title: isRemoteSet
            ? 'Продажа брелока от шлагбаума'
            : 'Перед продажей пультов от шлагбаума<br>Укажите модель пульта в настройках',
          color: '#1E6CEB',
          icon: 'mdi-car-connected',
          colorCard: 'rgba(172, 204, 172, 0.5)',
          colorCardIcon: '#85B285',
          isDisabled: !isRemoteSet,
          show: true,
          url: isRemoteSet ? remoteLinks[remoteKey] : null,
        },
        {
          title: this.barrier.barrier_open_phone
            ? 'Добавление номера телефона клиента в шлагбаум'
            : 'Укажите номер телефона устройства в настройках, для добавление телефона клиента в шлагбаум',
          color: '#1E6CEB',
          icon: 'mdi-phone-plus',
          colorCard: 'rgba(224, 179, 137, 0.5)',
          colorCardIcon: '#E0B389',
          // !this.barrier.barrier_open_phone
          isDisabled: true,
          show: this.hasOpeningType(this.barrier.opening_type, 'C'),
          click: this.barrier.barrier_open_phone ? this.openDialogAddNumber : null,
        },
      ];
    },
    statistics () {
      return [
        {
          label: 'Жилой комплекс',
          value: this.getResidentialComplexName(this.barrier.residential_complex_id),
          check: this.getResidentialComplexName(this.barrier.residential_complex_id),
          isRouterLink: true,
          to: `/residential-complexes/${this.barrier.residential_complex_id}/view`,
        },
        { label: 'Абонентов', value: this.totalAccounts, check: this.totalAccounts },
        { label: 'Временные абоненты', value: this.totalTemporarySubscribers, check: this.totalTemporarySubscribers },
        { label: 'Номера автомобилей', value: this.totalNumberCars, check: this.totalNumberCars },
        { label: 'Белый список', value: this.totalWhitePhoneNumbers, check: this.totalWhitePhoneNumbers },
      ];
    },
    displayTitle () {
      if (this.barrier.passage_type === 'G') {
        return 'Ворота';
      }
      return 'Шлагбаум';
    },
  },
  mounted () {
    if (window.innerWidth < 600) {
      this.isMobile = true;
    }
    this.snapshot = this.barrier.snapshot;
    this.channel.address = this.barrier.address;
  },
  methods: {
    ...mapActions({
      openBarrier: 'Barriers/openBarrier',
      unlockBarrier: 'Barriers/unlockBarrier',
      blockBarrier: 'Barriers/blockBarrier',
      getCheckCamerasBarrier: 'Barriers/getCheckCamerasBarrier',
      getBarrier: 'Barriers/getBarrier',
      makeCall: 'Barriers/makeCall',
      updateSnapshot: 'Barriers/updateSnapshot',
    }),
    displayLabelSettings (item, value) {
      return ENUM_LABELS[item]?.[value] || 'Не указано';
    },
    handleClick (page) {
      if (!page.isDisabled && page.url) {
        window.open(page.url, '_blank');
      }
      if (page.click) {
        page.click();
      }
    },
    openDialogAddNumber () {
      this.isModalOpen = true;
    },
    closeModal () {
      this.isModalOpen = false;
    },
    handleSave (data) {
      this.isModalOpen = false;
    },
    toggleIntercoms () {
      this.showAllIntercoms = !this.showAllIntercoms;
    },
    getIcon (page) {
      return this.activeButton === page.title ? page.iconHover : page.icon;
    },
    hasOpeningType (value, type) {
      const values = Array.isArray(value)
        ? value
        : value === 'CG'
          ? ['C', 'G']
          : (value ? String(value).split(',').map(v => v.trim()).filter(Boolean) : []);
      return values.includes(type);
    },
    openDeviceClick () {
      if (this.hasOpeningType(this.barrier.opening_type, 'C') && this.barrier.sip_status === null) {
        this.makeCallToOpen();
        return;
      }

      if (this.barrier.doors.length >= 2) {
        this.showDialogTwoButtons = true;
        return;
      }
      this.openDoor(1);
    },
    updateSnapshotClick () {
      this.loading = true;
      this.updateSnapshot(this.barrier.id)
        .then((response) => {
          this.snapshot = response.snapshot;
          if (response.status) {
            this.$flash_success('Изображение обновилось');
          } else {
            this.$flash_warning('Не удалось обновить изображение');
          }
        })
        .catch(() => {
          this.$flash_warning('Ошибка обновления изображения шлагбаума');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    makeCallToOpen () {
      const phone = this.barrier.barrier_open_phone;

      if (!phone) {
        this.$flash_warning('Добавьте номер телефона для открытия шлагбаума.');
        return;
      }

      this.makeCall({ phone: phone })
        .then(() => {
          this.$flash_success('Звонок успешно инициализирован, шлагбаум открывается');
        })
        .catch(() => {
          this.$flash_warning('Ошибка при открытии шлагбаума');
        });
    },
    openDoor (doornum) {
      this.openBarrier({
        id: this.barrier.id,
        doornum: doornum,
      })
        .then(() => {
          this.$flash_success('Открыто!');
        })
        .catch(() => {
          this.$flash_warning('Ошибка при открытии');
        });
    },
    handleOpen (relayIndex) {
      this.showDialogTwoButtons = false;
      this.openDoor(relayIndex);
    },
    editDoorphone () {
      const value = this.barrier.id;
      let { id } = value;
      if (!id) {
        id = value;
      }
      this.$router.push({ name: 'EditBarrier', params: { id: id } });
    },
    openDetailDialogDevice () {
      this.detailDialog = true;
    },
    transitionWebDevice () {
      const hrefDevice = `http://${this.barrier.device.ip_address}.intercom.access.simdev.ru:5000/`;
      window.open(hrefDevice, '_blank');
    },
    zoomPhoto (photo) {
      this.currentZoomPhoto = photo;
      this.showZoomPhoto = true;
    },
    closeZoomPhoto () {
      this.showZoomPhoto = false;
      this.currentZoomPhoto = null;
    },
    getResidentialComplexName (id) {
      const complex = this.resComplexName.find(item => item.id === id);
      return complex ? complex.name : '';
    },
    blockingDevice () {
      this.blockBarrier(this.barrier.id)
        .then(() => {
          this.getBarrier({
            id: this.barrier.id,
          })
            .catch(() => {
              this.$flash_warning('Ошибка при загрузке информации');
            });
          this.$flash_success('Шлагбаум заблокирован на распознавания грз!');
        })
        .catch(() => {
          this.$flash_warning('Ошибка дейсвия.');
        });
    },
    unlockingDevice () {
      this.unlockBarrier(this.barrier.id)
        .then(() => {
          this.getBarrier({
            id: this.barrier.id,
          })
            .catch(() => {
              this.$flash_warning('Ошибка при загрузке информации');
            });
          this.$flash_success('Шлагбаум разблакирован на распознавания грз!!');
        })
        .catch(() => {
          this.$flash_warning('Ошибка дейсвия.');
        });
    },
    getDialogImage () {
      if (!this.isErrorStreamUrl) {
        if (this.disableRoleNameAdmin) {
          if (this.isFirstTimeDialogImageOpened) {
            if (this.$refs.Player) {
              this.$refs.Player.getPlayer();
            }
          } else {
            this.isFirstTimeDialogImageOpened = false;
          }
        }
        this.dialogImage = true;
      } else {
        this.$flash_danger('Ошибка видео, обновите страницу.');
      }
    },
    checkSize () {
      this.isCheckSizeSmall = window.innerWidth <= 600;
    },
    editBarrier (id) {
      this.$router.push({ name: 'EditBarrier', params: { id: id } });
    },
  },
};
</script>

<style lang="scss" scoped>
.routerLink {
  text-decoration: none;
}

.v-application a {
  color: cornflowerblue;
}

a:hover.routerLink {
  text-decoration: underline;
}
.row-click {
  cursor: pointer;
}

.image-barrier {
  cursor: pointer;
}
.action-list {
  border: 1px solid #1976d2;
  border-radius: 4px;
}
.hist-but {
  cursor: pointer;
  color: cornflowerblue;
}
.barrier-info, .barrier-info {
  color: rgba(0, 0, 0, 0.87);
}
.information p {
  margin-bottom: 4px;
}
.sip-history-header {
  position: sticky;
  top: 0;
  z-index: 999;
}
.action-container {
  text-align: -webkit-center;
}
.abonent-table-title {
  padding-top: 20px;
  padding-left: 30px;
}
@media screen and (max-width: 600px) {
  .action-column {
    display: inline-grid !important;
  }
  .barrier-info-one, .barrier-info-two {
    padding-left: 0;
    margin-left: 0;
  }
}
 //----------

.intercom-info {
  font-weight: 400 !important;
  padding-left: 15px;
  font-size: 16px;
}

.border {
  border-radius: 16px;
}
.information p {
  margin-bottom: 4px;
}

.v-application p {
  font-weight: 600;
  margin-bottom: 8px;
  font-size: 17px;
  font-family: 'Montserrat', sans-serif;
}

@media screen and (max-width: 1500px) {
  .v-application p {
    font-size: 16px
  }
  .apex-chart {
    height: auto;
  }
}
</style>
